module.exports = __webpack_public_path__ + "media/images/dingdong@2x-553c0e7b5b2b43bdf42d9d7a122841fe.png";